import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

import { useAppDispatch, useAppSelector } from '../../store';
import { closeLightboxes } from '../../store/verktoy/slice/verktoySlice';

export const AddVerktoyConfirmation = (): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const addedAktivitetName = useAppSelector(globalState => globalState.verktoy.addedAktivitetName);

  const resources = useGetResources();
  const handleClose = (): void => {
    dispatch(closeLightboxes());
  };
  return (
    <Modal
      ariaLabel="add-verktoy-confirmation-modal"
      testId="add-verktoy-confirmation"
      title={`${addedAktivitetName} ${resources?.addVerktoyConfirmationText}`}
      description={resources?.addVerktoy_description}
      onSuccess={handleClose}
      primaryButtonText={resources?.confirmBoxOk}
      onClose={handleClose}
    />
  );
};
